import { render } from "./country-selector.vue?vue&type=template&id=f515d164"
import script from "./country-selector.vue?vue&type=script&lang=js"
export * from "./country-selector.vue?vue&type=script&lang=js"

import "./country-selector.vue?vue&type=style&index=0&id=f515d164&lang=scss"

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__